// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries
import React from 'react'

import startsWith from 'lodash/startsWith'
import isUndefined from 'lodash/isUndefined'
import isNull from 'lodash/isNull'

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components
import { Link as GatsbyLink } from 'gatsby-plugin-react-intl'

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Locals
import OutLink from '../out-link'

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions
const { Fragment } = React

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------
/** Link */
const Link = ({ to, children, ...props }) => {
  const thatTo = isUndefined(to) || isNull(to) ? '#' : to
  const isOutLink =
    thatTo.startsWith('http') ||
    thatTo.startsWith('https') ||
    thatTo.startsWith('mailto:')
  const isHashLink = startsWith(thatTo, '#') || isUndefined(thatTo)

  return (
    <Fragment>
      {isOutLink === true ? (
        <OutLink to={thatTo} {...props}>
          {children}
        </OutLink>
      ) : (
        <Fragment>
          {isHashLink === true ? (
            <a href="#" {...props}>
              {children}
            </a>
          ) : (
            <GatsbyLink to={thatTo} activeClassName="active" {...props}>
              {children}
            </GatsbyLink>
          )}
        </Fragment>
      )}
    </Fragment>
  )
}

// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Exports
// ----------------------------------------------------------------------------
export default Link
